import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CanvasService } from '../../../services/canvas/canvas.service';

@Component({
  selector: 'nw-editable-text',
  templateUrl: './editable-text.component.html',
  styleUrls: ['./editable-text.component.scss'],
})
export class EditableTextComponent implements OnInit, OnDestroy {
  @Input()
  underline: boolean;

  @Input()
  id: string;

  @Input()
  dark: boolean;

  @Input()
  size: 's' | 'm' | 'l';

  @Input()
  inputWidth = 108;

  @Input()
  text: string;

  @Output()
  isActive = new EventEmitter<boolean>();

  @Output()
  textChanged = new EventEmitter<string>();

  @Output()
  currentTextValue = new EventEmitter<string>();

  editMode = false;

  @Input()
  editDisabled: boolean;

  @ViewChild('host') host: ElementRef;

  @ViewChild('input') input: ElementRef;

  sub: Subscription;

  // enterSubscription: Subscription;

  // @Input()
  // set selected(val: boolean) {
  //   if (val) {
  //     this.enterSubscription?.unsubscribe();
  //     this.enterSubscription = this.cs.keyEventSubscribe('Enter', () => {
  //       this.activateInput();
  //     });
  //   } else {
  //     this.enterSubscription?.unsubscribe();
  //   }
  // }

  @Input()
  set activate(val: boolean) {
    // console.log('et > activate', val);
    if (val) {
      this.activateInput();
    } else {
      this.deActivateInput();
      // this.textChanged.emit(this.text);
    }
  }

  activateInput() {
    this.editMode = true;
    this.isActive.emit(true);
    setTimeout(() => {
      // this.input.nativeElement.focus();
      this.input?.nativeElement.select();
    }, 10);
  }

  deActivateInput() {
    this.editMode = false;
    this.isActive.emit(false);
    setTimeout(() => {
      this.input?.nativeElement.blur();
    }, 10);
  }

  ngOnInit(): void {
    this.sub = this.cs.generalEventSubscribe('globalClick', () => {
      this.deActivateInput();
      if (this.changed) {
        this.save();
      }
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  // @HostListener('document:click', ['$event'])
  // async click(e: MouseEvent) {
  //   if (!this.editMode) {
  //     return;
  //   }
  //   if (!this.host.nativeElement.contains(e.target)) {
  //     this.finishEdit();
  //   }
  // }

  constructor(private readonly cs: CanvasService) {}

  clickText(e: MouseEvent) {
    if (this.editDisabled || this.editMode) {
      return;
    }
    e.stopPropagation();
    this.editMode = true;
    this.activateInput();
  }

  save() {
    this.changed = false;
    this.editMode = false;
    this.input.nativeElement.blur();
    this.textChanged.emit(this.text);
  }
  changed = false;

  change(event: KeyboardEvent) {
    const key = event.key;
    this.cs.consumeKeyEvent(key);
    this.changed = true;
    if (key === 'Enter' || key === 'Tab') {
      this.save();
    } else {
      event.stopPropagation();
    }
  }

  keyUp(event: KeyboardEvent) {
    this.currentTextValue.emit(this.text);
  }
}
